import { useState, useEffect } from 'react';
import { dashboardService } from '../services';

interface CreditInfo {
    availableCredits: number | null;
    usedCredits: number;
    pendingCredits: number;
    isUnlimited: boolean;
    isLoading: boolean;
}

/**
 * Hook zum Laden der Credit-Informationen für den aktuellen Benutzer.
 * Nutzt den Dashboard-Status Endpoint.
 */
export const useCreditInfo = (enabled: boolean = true) => {
    const [creditInfo, setCreditInfo] = useState<CreditInfo>({
        availableCredits: null,
        usedCredits: 0,
        pendingCredits: 0,
        isUnlimited: true,
        isLoading: true
    });

    useEffect(() => {
        const fetchCreditInfo = async () => {
            if (!enabled) {
                setCreditInfo(prev => ({ ...prev, isLoading: false }));
                return;
            }

            try {
                const data = await dashboardService.getDashboardStatus();

                // Verwende direkt die Backend-berechneten Werte
                const isUnlimited = data?.creditsUnlimited ?? (data?.analysisCredits === null || data?.analysisCredits === undefined);

                setCreditInfo({
                    availableCredits: data?.remainingCredits ?? null,
                    usedCredits: data?.usedCredits ?? 0,
                    pendingCredits: data?.pendingCredits ?? 0,
                    isUnlimited,
                    isLoading: false
                });
            } catch (error) {
                console.error('Fehler beim Laden der Credit-Info:', error);
                setCreditInfo(prev => ({ ...prev, isLoading: false }));
            }
        };

        fetchCreditInfo();
    }, [enabled]);

    return creditInfo;
};

export default useCreditInfo;
